import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { closeAllModals, closeModal, openModal } from 'reducers/modalReducer';
import EmbeddedIFrame from 'views/Frames/EmbeddedIFrame';
import { ClmPortalIncomingPostMessageTypes } from 'utils/postMessageUtil';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import PageTitleToken from 'components/Common/PageTitleToken';
import { ZfDialog, ZfDialogHeader } from '@zafire/react';

const ClientReadinessModal = ({ brUid }: { brUid: string }) => {
  const dispatch = useDispatch();
  const runtimeConfig = useRuntimeConfig();
  const { t } = useTranslation();

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    async function handleMessage(event: MessageEvent) {
      const message = event.data.message;
      if (message === ClmPortalIncomingPostMessageTypes.CLOSE_MODAL) {
        dispatch(closeModal('ClientReadinessModal'));
      }
      if (message === ClmPortalIncomingPostMessageTypes.SHOW_REQUEST_COVERAGE_DOMICILE_EXCEPTION) {
        dispatch(closeModal('ClientReadinessModal'));
        dispatch(
          openModal({
            modalType: 'CoverageDomicileApprovalModal',
            modalProps: {
              brUid: event.data.value.brUid,
            },
          }),
        );
      }
    }

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <ZfDialog
      id="client-readiness-modal"
      data-testid="client-readiness-modal"
      show
      aria-labelledby="dialog-title"
      onDialogClose={() => dispatch(closeAllModals())}
    >
      <ZfDialogHeader>{t('clientReadiness.modal.title')}</ZfDialogHeader>
      <PageTitleToken />
      <EmbeddedIFrame
        id="kyc-client-readiness-iframe"
        title="Client Readiness"
        url={`${runtimeConfig.configData.iframeUrls.brCoreIframe}/business-relationship/${brUid}/readiness`}
        centered
        height="80vh"
      />
    </ZfDialog>
  );
};

export default ClientReadinessModal;
